import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class ReferralService {
  private url = environment.apiUrl;

  constructor(private http: HttpClient) {}

  // Owner settings are nested inside `account_settings.configuration.referral`.
  getAccountSetting(accountId: string): Observable<any> {
    return this.http.get(`${this.url}/account_settings/${accountId}?$mode=Company`);
  }

  updateAccountSetting(accountId: string, data: FormData): Observable<any> {
    return this.http.put(`${this.url}/account_settings/${accountId}`, data);
  }

  generateMyCode(): Observable<{ code: string }> {
    return this.http.post<{ code: string }>(`${this.url}/referral_code`, { mode: "generate" });
  }

  validateCode(code: string, amount: number, currencyCode?: string): Observable<any> {
    return this.http.post(`${this.url}/referral_code`, {
      mode: "validate",
      code,
      amount,
      currency_code: currencyCode,
    });
  }

  getWalletBalance(): Observable<{
    available: number;
    pending: number;
    currency_code: string;
    breakdown: { credits_available: number; debits_available: number; credits_pending: number };
  }> {
    return this.http.get<any>(`${this.url}/wallet_balance`);
  }

  listMyWalletTransactions(page = 0, limit = 20): Observable<any> {
    return this.http.get(`${this.url}/wallets?$mode=mine&$page=${page}&$limit=${limit}`);
  }

  listMyReferrals(page = 0, limit = 20): Observable<any> {
    return this.http.get(`${this.url}/referrals?$mode=mine&$page=${page}&$limit=${limit}`);
  }
}
